import React from 'react'

const DoctorsSection = () => {
  return <div>DoctorsSection</div>
}

export default DoctorsSection
